import {create} from 'zustand';

const useClassroomStore = create(set => ({
  duration: null,
  timerDuration: null,
  initiateTimer: false,

  setDurations: ({duration, timerDuration}) =>
    set({
      duration,
      timerDuration,
    }),

  resetDurations: () =>
    set({
      duration: null,
      timerDuration: null,
      initiateTimer: false,
    }),

  setBeginTimer: initiateTimer => set({initiateTimer}),
}));

export default useClassroomStore;
